namespace GeniuzPOS.AdvPromo {
    export interface PsAdvPromoItemForm {
        PmGroupId: Serenity.StringEditor;
        PmId: Serenity.StringEditor;
        PmType: Serenity.IntegerEditor;
        PmExtCode: Serenity.StringEditor;
        PmStepNo: Serenity.IntegerEditor;
        PmDesc: Serenity.StringEditor;
        PmOrder: Serenity.IntegerEditor;
        LineItemNo: Serenity.IntegerEditor;
        EndBillPmType: Serenity.RadioButtonEditor;
        Qty: Serenity.DecimalEditor;
        Amt: Serenity.DecimalEditor;
        FreeLpFg: Serenity.RadioButtonEditor;
        FreeQty: Serenity.DecimalEditor;
        LpPrice: Serenity.DecimalEditor;
        AssortFg: Serenity.RadioButtonEditor;
        ItemType: Serenity.RadioButtonEditor;
        ListFg: Serenity.RadioButtonEditor;
        PluCode: Serenity.LookupEditor;
        StyleCode: Serenity.LookupEditor;
        BrandCode: Serenity.LookupEditor;
        CatCode: Serenity.LookupEditor;
        SubCat1Code: Serenity.LookupEditor;
        SubCat2Code: Serenity.LookupEditor;
        SupplCode: Serenity.LookupEditor;
    }

    export class PsAdvPromoItemForm extends Serenity.PrefixedContext {
        static formKey = 'AdvPromo.PsAdvPromoItem';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsAdvPromoItemForm.init)  {
                PsAdvPromoItemForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.RadioButtonEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.LookupEditor;

                Q.initFormType(PsAdvPromoItemForm, [
                    'PmGroupId', w0,
                    'PmId', w0,
                    'PmType', w1,
                    'PmExtCode', w0,
                    'PmStepNo', w1,
                    'PmDesc', w0,
                    'PmOrder', w1,
                    'LineItemNo', w1,
                    'EndBillPmType', w2,
                    'Qty', w3,
                    'Amt', w3,
                    'FreeLpFg', w2,
                    'FreeQty', w3,
                    'LpPrice', w3,
                    'AssortFg', w2,
                    'ItemType', w2,
                    'ListFg', w2,
                    'PluCode', w4,
                    'StyleCode', w4,
                    'BrandCode', w4,
                    'CatCode', w4,
                    'SubCat1Code', w4,
                    'SubCat2Code', w4,
                    'SupplCode', w4
                ]);
            }
        }
    }
}
